import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading text-lg">
                韩
              </span>
              <span className="font-heading text-xl text-background-50">韩漫网</span>
            </div>
            <p className="text-sm leading-relaxed text-background-400">
              韩漫网 —— 整合韩漫大全、下拉式韩国漫画和在线观看功能，提供一站式韩漫阅读解决方案，让您的阅读过程无需跳转，体验连贯流畅。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              <a href="#footer-categories" className="text-background-50">漫画分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              <a href="#footer-links" className="text-background-50">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  全部漫画
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  使用条款
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              <a href="#footer-contact" className="text-background-50">联系我们</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-xs"></i>
                </span>
                <span>contact@hanmanwang.com</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-xs"></i>
                </span>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-xs"></i>
                </span>
                <span>上海市浦东新区张江高科技园区</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 韩漫网 HanManWang.com 版权所有
          </p>
          <p className="text-xs text-background-500">
            <a href="https://beian.miit.gov.cn" target="_blank" rel="nofollow noopener" className="hover:text-background-400 transition-colors cursor-pointer">
              沪ICP备2024000001号
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}